import { fromEvent } from "rxjs";
import { IAddressLookupService } from "../../../services/interfaces/addressLookupService";
import { AddressComponent } from "../addressComponent";
import { first } from "rxjs/operators";
import { hide, show } from "../../../utils";
import { SessionDto } from "@se/platform";
import { ILoggingService } from "../../../services/interfaces/loggingService";

class ReadonlyView {

    private previewEl: HTMLElement;
    private editButtonEl: HTMLElement;
    private searchButtonEl: HTMLElement;

    constructor(private viewEl: HTMLElement, private component: AddressComponent, private session: SessionDto, private addressLookupService: IAddressLookupService, private appInsights: ILoggingService) {

        this.previewEl = viewEl.querySelector<HTMLElement>(".js-preview");
        this.editButtonEl = viewEl.querySelector<HTMLElement>(".js-edit");
        this.searchButtonEl = viewEl.querySelector<HTMLElement>(".js-search");

        this.searchButtonEl.addEventListener("click", (e) => {
            e.preventDefault();
            this.component.resetSearch();
        });
    }

    public async displayAddress(addressId: string) {
        const response = await this.addressLookupService.getAddress(this.session, addressId)
        
        const address = response.content;
        this.previewEl.innerHTML = "loading";

        if (response.wasSuccessful) {
            this.previewEl.innerHTML = address.companyName;

            if (address.addressLine1) {
                this.previewEl.innerHTML += "<br>" + address.addressLine1;
            }

            if (address.addressLine2) {
                this.previewEl.innerHTML += "<br>" + address.addressLine2;
            }

            if (address.addressLine3) {
                this.previewEl.innerHTML += "<br>" + address.addressLine3;
            }

            if (address.city) {
                this.previewEl.innerHTML += "<br>" + address.city;
            }

            if (address.postcode) {
                this.previewEl.innerHTML += "<br>" + address.postcode;
            }

            this.component.setValue(response.content);

            this.editButtonEl.addEventListener("click", (e) => {
                e.preventDefault();
                this.component.editAddress(address);
            });

            this.show();
            this.editButtonEl.focus();
        }
        else {
            this.appInsights.LogMessage("Could not retrieve company in readonlyView.ts");
        }
    }

    public show() {
        show(this.viewEl);
    }

    public hide() {
        hide(this.viewEl);
    }
}

export { ReadonlyView }